import React from 'react';
import { Row, Space } from 'antd';
import styles from './not-found.module.scss';
import { i18nKey } from 'src/locales/i18n';
import { useTranslation } from 'react-i18next';
import ProductButton from 'src/components/product-button/product-button';
import { Link } from 'react-router-dom';
import { PAGE_ROUTE } from 'src/constants/route';

const NotFoundPage = () => {
    const { t } = useTranslation();
    return (
        <Row justify="center" className={styles.notFoundGroup}>
            <Space direction="vertical" className={styles.contentContainer}>
                <div className={styles.textNotFound}>{t(i18nKey.notFound.title)}</div>
                <div className={styles.subTextNotFound}>{t(i18nKey.notFound.subTitle)}</div>
                <ProductButton className={styles.btnHome}>
                    <Link to={PAGE_ROUTE.HOME}>{t(i18nKey.btnBackToShop)}</Link>
                </ProductButton>
            </Space>
        </Row>
    );
};

export default NotFoundPage;
